import React, { Component } from "react";
import { CardBody, Card, Label, Col, Button, Row } from "reactstrap";
import './style.css'
import { Preloading } from '../../components/UI/Preloader/action';
import { connect } from "react-redux";
import { addIfscUserMasterUpload, ifscUserMasterTemplateRequest, ifscUserMasterDataExcelRequest, ifscUserMasterListRequest  } from "./action";
import { toast } from 'react-toastify';
import fileSaver from 'file-saver';
// import { DEFAULT_PAGE_SIZE, DEFAULT_PAGE_NUMBER } from './IfscUserMasterTable/constants';
// import IfscUserMasterFilterForm from './IfscUserMasterFilter/index';
// import IfscUserMasterTable from './IfscUserMasterTable/index';
// import { buildIfscUserMasterListFetchRequest } from './helper';


class IfscUserMasterUploadUtility extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: "",
      ifscUserMasterExcelFile: '',
      noExcelUploadWarning: '',
      // showFilter: false,
      // pageSize: this.props.defaultPageSize || DEFAULT_PAGE_SIZE,
      // pageNumber: DEFAULT_PAGE_NUMBER,
      // currentFilter: {},
      // sorted: [{ 
      //   id: "createdAt",
      //   desc: true
      // }]
    };
  }

  componentDidUpdate(prevProps) {

    if (this.props.ifscUserMasterTemplateSuccess !== prevProps.ifscUserMasterTemplateSuccess) {
      this.props.preloading(false)
      var blob = new Blob([this.props.ifscUserMasterTemplateSuccess.data], { type: 'application/octet-stream' });
      fileSaver.saveAs(blob, `IFSC_User_Master_Template.xlsx`);
      toast.success(
        <div>
          <i className="fa fa-check-circle fa-lg"></i>&nbsp;File Downloaded Successfully
        </div>
      );
    }
    if (this.props.ifscUserMasterTemplateFailure !== prevProps.ifscUserMasterTemplateFailure) {
      this.props.preloading(false)
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Some error occured<br />&nbsp;Please try again!
        </div>
      );
    }

    if (this.props.ifscUserMasterDataExcelSuccess !== prevProps.ifscUserMasterDataExcelSuccess) {
      this.props.preloading(false)
      var blob = new Blob([this.props.ifscUserMasterDataExcelSuccess.data], { type: 'application/octet-stream' });
      fileSaver.saveAs(blob, `IFSC_User_Master_Data.xlsx`);
      toast.success(
        <div>
          <i className="fa fa-check-circle fa-lg"></i>&nbsp;File Downloaded Successfully
        </div>
      );
    }
    if (this.props.ifscUserMasterDataExcelFailure !== prevProps.ifscUserMasterDataExcelFailure) {
      this.props.preloading(false)
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Some error occured<br />&nbsp;Please try again!
        </div>
      );
    }

    if (this.props.addIfscUserMasterUploadSuccess !== prevProps.addIfscUserMasterUploadSuccess) {
      this.props.preloading(false)
      const successMessage = this.props.addIfscUserMasterUploadSuccess?.message || 
                             this.props.addIfscUserMasterUploadSuccess?.data?.message || 
                             this.props.addIfscUserMasterUploadSuccess?.data || 
                             'Upload successful';
      toast.success(
        <div>
          <i className="fa fa-check-circle fa-lg"></i>&nbsp; {successMessage}
        </div>
      );
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    }
    if (this.props.addIfscUserMasterUploadFailure !== prevProps.addIfscUserMasterUploadFailure) {
      this.props.preloading(false)
      const errorMessage = this.props.addIfscUserMasterUploadFailure?.data?.data || 
                           this.props.addIfscUserMasterUploadFailure?.data?.message || 
                           this.props.addIfscUserMasterUploadFailure?.data || 
                           'Upload failed';
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle fa-lg"></i>&nbsp; {errorMessage}
        </div>
      );
    }

    if (this.props.addIfscUserMasterUploadFailureFile && this.props.addIfscUserMasterUploadFailureFile !== prevProps.addIfscUserMasterUploadFailureFile) {
      this.props.preloading(false)
      var blob = new Blob([this.props.addIfscUserMasterUploadFailureFile], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fileSaver.saveAs(blob, "IFSC_User_Master_Errors.xlsx");
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle fa-lg"></i>&nbsp; Upload failed. Please check the downloaded error file for details.
        </div>
      );
    }
  }
  
//  openFilter = () => {
//   this.setState({ showFilter: true });
// };

// closeFilter = () => {
//   this.setState({ showFilter: false });
// };

// onSortedChange = (sorted) => {
//     this.setState({ 
//       sorted: sorted[0],
//       pageNumber: DEFAULT_PAGE_NUMBER 
//     }, () => {
//       this.fetchIfscUserMasterList();
//     });
//   };


//   fetchIfscUserMasterList = () => {
//     const { pageNumber, pageSize, currentFilter, sorted } = this.state;
//     const requestBody = buildIfscUserMasterListFetchRequest({pageNumber,pageSize,filter: currentFilter,sorted});
//     this.props.ifscUserMasterListRequest(requestBody);
//   };



//   componentDidMount() {
//     this.fetchIfscUserMasterList();
//   }

//   handleApplyFilter = (filter) => {
//     this.setState({ 
//       showFilter: false,
//       currentFilter: filter, 
//       pageNumber: DEFAULT_PAGE_NUMBER 
//     }, () => {
//       this.fetchIfscUserMasterList();
//     });
//   };

//   onPageChange = (pageIndex) => {
//     this.setState({ pageNumber: pageIndex }, () => {
//       this.fetchIfscUserMasterList();
//     });
//   };

//   onPageSizeChange = (pageSize) => {
//     this.setState({ 
//       pageSize, 
//       pageNumber: DEFAULT_PAGE_NUMBER 
//     }, () => {
//       this.fetchIfscUserMasterList();
//     });
//   };

  handleTemplateDownload = () => {
    this.props.preloading(true)
    this.props.ifscUserMasterTemplateRequest();
  }

  handleDownloadIfscUserData = () => {
    this.props.preloading(true)
    this.props.ifscUserMasterDataExcelRequest();
  }

  uploadExcel = (event) => {
    this.setState({
      ifscUserMasterExcelFile: event.target.files[0]
    })
    event.preventDefault();
    event.target.value = null;
  }

  handleSubmit = () => {
    if (!this.state.ifscUserMasterExcelFile) {
      this.setState({ noExcelUploadWarning: '*Please upload the filled request template!' })
    }
    if (this.state.type === '') {
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Please Select Upload Type
        </div>
      );
    }

    else {
      this.props.addIfscUserMasterUpload({ file: this.state.ifscUserMasterExcelFile, type: this.state.type });
      this.props.preloading(true);
    }
  }

  render() {
    // const paginatedData = this.props.ifscUserMasterViewPaginatedList || {};
    // const data = paginatedData.content || [];
    // const pagination = paginatedData.pageable || {};
    // const totalPages = paginatedData.totalPages || 0;

    return (
      <Col>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="mb-0 text-center">IFSC User Master Upload</h4>
        </div>
        <Card>
          <CardBody>
            <Label>Upload IFSC User Master Template</Label>
            <Row>
              <Col sm="22">
                <Button
                  color="primary"
                  onClick={this.handleTemplateDownload}
                  className="btn color-excel-download "
                >
                  <i className="fa fa-file-excel-o fa-lg"></i>
                  &nbsp;&nbsp;Download Template
                </Button>
                <Row
                  color="primary"
                  className="btn btn-primary ml-0 position-relative excel-upload-btn browse-files ml-3"
                  title="Upload Request Template"
                >
                  <input
                    onChange={this.uploadExcel}
                    type="file"
                    name="file"
                    id="file"
                    className="upload-file"
                    title="Upload Request Template"
                    accept=".xlsx"
                  />
                  <i className="fa fa-paperclip color-888 rotate-90deg p-1 fa-lg" />{" "}
                  Upload Template
                </Row>
                <Label className="uploadType">Upload Type : </Label>
                <div className="ifscUserType">
                  <input name="type" type="radio" value="add" onChange={e => { this.setState({ type: e.target.value }) }} />
                  &nbsp;&nbsp;Add New Records
                  <label>
                    <input name="type" type="radio" value="edit" onChange={e => { this.setState({ type: e.target.value }) }} />
                    &nbsp;&nbsp;Update Existing
                  </label>
                </div>
                <Button
                  className="ml-5"
                  color="primary"
                  onClick={this.handleSubmit}
                >
                  Submit
                </Button>
                <Button className="ml-5"
                  color="success" onClick={this.handleDownloadIfscUserData}>Download Existing Data</Button>
                  {/* <Button className="ml-2" color="primary" onClick={this.openFilter}>
                  <i className="fa fa-filter fa-lg"></i> Apply Filters  
                </Button> */}
                <Row className={(this.state.ifscUserMasterExcelFile) ? "text-muted ml-1 transaction-file-name-text" : "text-danger ml-1 noUploadWarning-text"}>{(this.state.ifscUserMasterExcelFile) ? this.state.ifscUserMasterExcelFile.name : this.state.noExcelUploadWarning}</Row>
                

              </Col>
            </Row>
          </CardBody>
        </Card>
    
      {/* <IfscUserMasterFilterForm
        isOpen={this.state.showFilter}
        toggle={this.closeFilter}
        onApply={this.handleApplyFilter}
      /> */}


      
      
      {/* <IfscUserMasterTable
        paginatedResponse={this.props.ifscUserMasterViewPaginatedList}
        loading={this.props.loading}
        pageSize={this.state.pageSize}
        pageNumber={this.state.pageNumber}
        onPageChange={this.onPageChange}
        onPageSizeChange={this.onPageSizeChange}
        sorted={this.state.sorted}
        onSortedChange={this.onSortedChange}
      /> */}

      </Col>
    );
  }
}



const mapStateToProps = (state, ownProps) => ({
  ifscUserMasterTemplateSuccess: state.ifscUserMasterReducer.ifscUserMasterTemplateSuccess,
  ifscUserMasterTemplateFailure: state.ifscUserMasterReducer.ifscUserMasterTemplateFailure,
  addIfscUserMasterUploadSuccess: state.ifscUserMasterReducer.addIfscUserMasterUploadSuccess,
  addIfscUserMasterUploadFailure: state.ifscUserMasterReducer.addIfscUserMasterUploadFailure,
  addIfscUserMasterUploadFailureFile: state.ifscUserMasterReducer.addIfscUserMasterUploadFailureFile,
  ifscUserMasterDataExcelSuccess: state.ifscUserMasterReducer.ifscUserMasterDataExcelSuccess,
  ifscUserMasterDataExcelFailure: state.ifscUserMasterReducer.ifscUserMasterDataExcelFailure,
  ifscUserMasterViewPaginatedList: state.ifscUserMasterReducer.ifscUserMasterListSuccess,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
  ifscUserMasterTemplateRequest: () => dispatch(ifscUserMasterTemplateRequest()),
  ifscUserMasterDataExcelRequest: () => dispatch(ifscUserMasterDataExcelRequest()),
  addIfscUserMasterUpload: (data) => dispatch(addIfscUserMasterUpload(data)),
  ifscUserMasterListRequest: (data) => dispatch(ifscUserMasterListRequest(data)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IfscUserMasterUploadUtility);
